/* Small shared lifecycle: one controller per element, released on editor unload. */
(function () {
  'use strict';
  if (window.Nowar) return;
  const registry = new Map();
  function visit(root, selector, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }
  function mount(entry, root) {
    visit(root, entry.selector, element => {
      if (entry.instances.has(element)) return;
      const controller = new AbortController();
      const dispose = entry.create(element, controller.signal);
      entry.instances.set(element, () => { controller.abort(); if (dispose) dispose(); });
    });
  }
  window.Nowar = {
    register(name, selector, create) {
      if (registry.has(name)) return;
      const entry = {selector, create, instances: new Map()};
      registry.set(name, entry);
      mount(entry, document);
    },
    money(cents, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'EUR', minimumFractionDigits: 0
      }).format(Number(cents) / 100);
    },
    route(path) { return (window.Shopify?.routes?.root || '/') + path; },
    motion() { return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  };
  document.addEventListener('shopify:section:load', event => {
    registry.forEach(entry => mount(entry, event.target));
  });
  document.addEventListener('shopify:section:unload', event => {
    registry.forEach(entry => entry.instances.forEach((dispose, element) => {
      if (element === event.target || event.target.contains(element)) {
        dispose(); entry.instances.delete(element);
      }
    }));
  });
})();
